// @ts-ignore: Unreachable code error


//兼容低端机型
// require("es6-promise").polyfill();
// require("babel-polyfill");

// import { isFunction, isString } from "./share";
import Http from "./ajax.config";
const $http = new Http();
import io from 'socket.io-client';

// socket.io 监听的频道，需要和之前的rest接口做一个映射。
// 因为不能用send 所以需要在send的时候使用rest post请求

const versionMapper = {
  'spot/upsAndDownsRanking': '/open/home/page/ups/and/downs/ranking',
  'spot/ticker': '/open/exchange/trade/quotations',
  'spot/redenvelope': '/open/exchange/redenvelope/notice',
  'spot/match': '/spot-all/trade_limit_fills',
  'spot/level2': '/spot-all/market/order_book/LEVEL2_20',
  'spot/candle': '/open/exchange/kline/data'
}

/**
 *
 *
 * *****基础实现类、可直接与socket对接的、不需要额外逻辑的*****/
export class SocketIO {
    SOCKET = null;

    //创建连接
    $$open(ws, reconnectCB) {
      let _success = () => {
        this.openSuccess();
      }
      let _disconnenct = () => {
        console.log('_disconnenct::')
        this.disconnenct()
        if (reconnectCB && typeof reconnectCB == 'function') {
          setTimeout(reconnectCB, 6000)
        }
      }
      let _fail = () => {
        // 使用socket.io的重连机制
        // this.openFail();
      }

      this.SOCKET = io(ws, {
        // reconnectionAttempts: 1000,
        // reconnectionDelay: 6000,
        // reconnectionDelayMax: 10000,
        reconnection: false,
        transports: ['websocket']
      });
      // on reconnection, reset the transports option, as the Websocket
      // connection may have failed (caused by proxy, firewall, browser, ...)
      this.SOCKET.on('reconnect_attempt', () => {
        socket.io.opts.transports = ['websocket'];
      });
      this.SOCKET.debug = null;
      this.SOCKET.open();

      this.SOCKET.on('connect', _success);
      this.SOCKET.on('disconnect', _disconnenct);
      this.SOCKET.on('connect_error', _fail);

      this.SOCKET.on('subscribe', (res) => {
        const rsp = JSON.parse(pako.inflateRaw(res, { to: 'string' }));
        // const rsp = res
        let data = {
          code: 0,
          success: true,
          data: (rsp.data && typeof rsp.data === "string") ? JSON.parse(rsp.data) : rsp.data
        };

        this.onmessage({
          url: rsp.channel,
          res: data
        });
      })
    }
    //关闭连接
    $$close(cb) {
      this.SOCKET.close()
      if (cb && typeof cb == 'function') {
        setTimeout(cb, 6000)
      }
    }
    //发送订阅
    $$0n(url, data, callback, succ) {
      this.SOCKET.emit('subscribe', JSON.stringify({
        args: url
      }), (ack) => {
        //
      });
      if (succ && typeof succ == 'function') {
        succ()
      }
    }
    //发送消息
    $$send(url, data, callback) {
      this.SOCKET.emit(url, data, callback)
      for (let key in versionMapper) {
        if (url.indexOf(key) != -1) {
          $http.post(versionMapper[key], data, callback)
          return
        }
      }
    }
    //取消订阅
    $$off(url, callback) {
      this.SOCKET && this.SOCKET.emit('unsubscribe', JSON.stringify({
        args: url
      }), callback)
      // console.warn("ws unsubscribe topic：" + url);
    }

    //连接成功后函数， 可在子类中实现
    openSuccess() {}
    //断开连接后函数， 可在子类中实现
    disconnenct() {}
    //连接失败后函数， 可在子类中实现
    openFail() {}
    //消息订阅后的发布， 可在子类中实现
    onmessage() {}
}


  /**
   *
   *
   * ****个性化类*******/
  export default class Socket extends SocketIO {
    constructor() {
      super();
    }

    /*
     * Status连接状态码
     * 0、未连接
     * 1、连接成功
     */
    Status = 0;
    WsUrl = "";
    /*
     * 订阅数据存储，map对象
     * kay: url
     * value: [ {url, data, callback}, ...... ]
     */
    ListenCopy = new Map();
    //订阅成功的ws Map，用于拦截客户端重复订阅
    ListenSuccessMap = {};

    getListenCopy(url) {
      return this.ListenCopy.get(url); // 从Map中获取指定URL的监听配置
    }
    hasListenCopy(url) { // 检查Map中是否存在指定URL的监听配置
      return this.ListenCopy.has(url);
    }
    setListenCopy(url, data, callback, succ) { // 设置或更新URL的监听配置到Map中
      const _data = [{
        url,
        data,
        callback,
        succ
      }];
      if (this.hasListenCopy(url)) {
        if(url!='spot/mini24-market-ticker:ALL'){
            let arr = this.getListenCopy(url);
        const hasFun = arr.filter(v => v.callback === callback).length > 0;
        arr = hasFun ? arr.map(v => {
          if (v.callback === callback) v = {
            url,
            data,
            callback,
            succ
          };
          return v;
        }) : arr.concat(_data);
        this.ListenCopy.set(url, arr);
        }

      
      } else {
        this.ListenCopy.set(url, _data);
      }
    }
    removeListenCopy(url, callback) {
      if (this.hasListenCopy(url)) {
        let arr = this.getListenCopy(url).filter(v => v.callback !== callback);
        this.ListenCopy.set(url, arr);
      }
    }
    clearListenCopy() {
      this.ListenCopy.clear();
    }
    setListenSuccessMap(url) {
      this.ListenSuccessMap[url] = true;
    }
    hasListenSuccessMap(url) {
      return this.ListenSuccessMap[url] === true;
    }
    removeListenSuccessMap(url) {
      delete this.ListenSuccessMap[url]
    }
    onBeforeFilter(url, data, callback, succ) {
      if (this.hasListenSuccessMap(url)) return;
      this.setListenSuccessMap(url);
      this.$$0n(url, data, callback, succ);
    }
    on(url, data, callback, succ) {
      this.setListenCopy(url, data, callback, succ);
      this.Status === 1 ? this.onBeforeFilter(url, data, callback, succ) : null;
    }
    off(url, callback, succ) {
      // this.$$off(url, succ);
      if (this.hasListenCopy(url)) {
        if (this.getListenCopy(url).length > 1) {
          this.removeListenCopy(url, callback);
        } else {
          this.$$off(url, succ);
          this.removeListenCopy(url, callback);
          this.removeListenSuccessMap(url);
        }
      }
    }
    send(url, data, callback) {
      this.$$send(url, data, callback)
    }
    checkSameWs(ws) {
      if (this.WsUrl === ws) {
        throw "exist socket connect.";
      }
    }
    //清除历史订阅信息，连接一个全新的ws时，优先使用
    clearResetOpen(ws, reconnectCB) {
      this.clearListenCopy();
      this.resetOpen(ws, reconnectCB);
    }
    //连接一个全新的ws时，优先使用
    resetOpen(ws, reconnectCB) {
      console.log('this.Status::', this.Status)
      if (this.Status === 1) {
        this.close(() => {
          this.open(ws, reconnectCB);
        })
      } else {
        this.open(ws, reconnectCB);
      }
    }
    //正常一般的连接ws
    open(ws, reconnectCB) {
      if (this.Status === 1) return;
      this.WsUrl = ws;
      if (!this.WsUrl) return console.error("empty socket channel");
      this.$$open(ws, reconnectCB);
    }
    openSuccess() {
      this.Status = 1;
      // console.warn("socket connected！");
      this.ListenCopy.forEach((v, k) => {
        v.map(v => this.onBeforeFilter(v.url, v.data, v.callback, v.succ));
      })
      this.listenws();
    }
    openFail() {
      this.Status = 0;
      this.ListenSuccessMap = {};
      console.warn("openFail");
      console.warn("socket try reconnect");
      this.$$close();
      // this.open(this.WsUrl);
    }
    close(cb) {
      console.warn("close");
      this.Status = 0;
      this.ListenSuccessMap = {};
      this.$$close(cb);
    }
    listenws() {
      document.onvisibilitychange = () => {
        if (document.visibilityState == "visible" && this.Status != 1) {
          console.warn("page redirect，socket disconnect");
          this.$$close();
          // this.open(this.WsUrl);
        }
      }
    }
    onmessage({
      url,
      res
    }) {
      // if (process.env.NODE_ENV != 'production') {
      //   console.log("ws data:", url, res);
      // }
      (this.getListenCopy(url)||[]).map(v => {
        typeof v.callback === 'function' && v.callback(res);
      })
    }
    getWS() {
      return this
    }
    disconnenct() {
      // nothing
    }
}



// WEBPACK FOOTER //
// ./src/common/ts/socket.js